import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import InspectorsList from "../../../inspections/components/Inspectors/InspectorsList";

const Inspectors = () => {
  return (
    <NavHeightAdjust>
      <InspectorsList />
    </NavHeightAdjust>
  );
};

export default Inspectors;
